<div id="mainContent" class="container">
    <button mat-raised-button class="btn-theme" style="float:right" matTooltip="Click to add assignment" matTooltipPosition="left"
    (click)="openModal(modalContent,'add')">
        <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;&nbsp; Location
    </button>
  </div>
  <br><br>
  <div class="animate__animated animate__fadeInLeft">
    <div class="col-md-10 offset-md-1">
      <table class="table table-responsive-md table-sm">
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Name</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let modalFormObj of modalFormObjList; index as i">
            <th scope="row">{{i+1}}</th>
            <td>{{modalFormObj.name}}</td>
            <td>
              <button class="btn btn-sm btn-outline-theme"  (click)="onEditClick(modalContent,modalFormObj)"
              matTooltip="Click to edit" matTooltipPosition="above">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button> &nbsp;&nbsp;
              <button class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(modalFormObj)"
              matTooltip="Click to delete" matTooltipPosition="above">
                <i class="fa fa-trash-o" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Modal Template -->
  <ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt">
      <h5 class="modal-title" id="modal-basic-title">Location</h5>
    </div>
    <div class="modal-body">

      <form [formGroup]="modalForm">
        <div class="row">
        <label class="col-sm-4">Name :</label>
        <div class="col-sm-8">
        <input id="name" name="name" type="text" class="form-control form-control-xs"
        formControlName="name" [class.is-invalid]="formErrors.name && formSubmitted" matTooltip="{{formErrors.name}}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
        </div>
        </div>

      </form>
    </div>
    <div class="modal-footer" style="">
      <div class="row col-md-12">
          <div class="col-sm-6"></div>
          <div class="col-sm-3">
              <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">Close</button>
          </div>
          <div class="col-sm-3">
              <button  type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button>
              <button  type="button" *ngIf="modalStatus=='edit'" class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">Update</button>
          </div>
      </div>
  </div>
  </ng-template>
